import React from "react";
import type { FormLabelProps } from "@mui/material";
import { FormLabel } from "@mui/material";

const fieldLabelFontSizes = {
  small: "0.75rem",
  medium: "0.875rem",
  large: "1rem",
} as const;

export interface FieldLabelProps extends FormLabelProps {
  size?: keyof typeof fieldLabelFontSizes;
}

export function FieldLabel({ size = "medium", sx, ...props }: FieldLabelProps) {
  return (
    <FormLabel
      {...props}
      sx={[{ typography: "fieldLabel", fontSize: fieldLabelFontSizes[size] }, ...(Array.isArray(sx) ? sx : [sx])]}
    />
  );
}
